import Department from '../../../dto/Department';
import Error from '../../../model/Error';
import axios from 'axios';

export default class OfferingDepartmentRepository {

    static findAll(clubId, withoutFilter) {
        return new Promise((resolve, reject) => {
            let url = '/club/clubs/' + clubId + '/offerings/departments';
            if (withoutFilter) {
                url = url + '?showAll=1';
            }
            axios
                .get(url)
                .then(response => resolve(response.data.data.map(data => Department.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
